import { Link, useLocation } from 'react-router-dom';

export function NotFoundPage() {
  const location = useLocation();
  return (
    <div className="mx-auto max-w-xl py-12 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">Not found</h1>
      <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
        No admin page at <code className="rounded bg-gray-100 dark:bg-gray-800 px-1 py-0.5 text-xs">/admin{location.pathname}</code>.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block rounded bg-brand-500 px-3 py-2 text-sm font-medium text-white hover:bg-brand-600 active:bg-brand-700"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
